/**
 * The pieces every /well-servicing screen draws the same way.
 *
 * IMPORTED, not copied: the register, chips, badge, panel, field and input are
 * the NDT screens' (which import the downhole ones), so the verticals stay one
 * shape. Nothing in those files is edited by this vertical.
 */
export {
  NdtBadge as WsBadge,
  NdtChip as WsChip,
  NdtChipRow as WsChipRow,
  NdtDialog as WsDialog,
  NdtEmpty as WsEmpty,
  NdtField as WsField,
  NdtFormError as WsFormError,
  NdtLoading as WsLoading,
  NdtPanel as WsPanel,
  NdtRegister as WsRegister,
  NdtSpec as WsSpec,
  NDT_INPUT as WS_INPUT,
  NDT_DATE_INPUT as WS_DATE_INPUT,
  NDT_PRIMARY as WS_PRIMARY,
  NDT_SECONDARY as WS_SECONDARY,
  isNotFound,
  type NdtColumn as WsColumn,
} from '../ndt-inspection/NdtBits';
export { DH_BAND_SECONDARY as WS_BAND_SECONDARY } from '../downhole/DownholeBits';

export const WS_EYEBROW = 'Well servicing';

/** A well has no status (rail claims no colour); sour is a flag, drawn as a red badge. */
export { WS_RAIL, WS_SOUR_SKIN } from '../../lib/well-servicing';
